<template>
  <div class="step-wrapper flex flex-wrap">
    <div
      @click="swichPage(v.link, i)"
      v-for="(v, i) in steps"
      :key="i"
      class="step"
      :class="{
        active: step === i + 1,
        prev: i < step,
        disabled: (disabledNext && i + 1 > step) || (disabledFirst && i === 0)
      }"
    >
      <span class="num">{{ i + 1 }}</span>
      <span>{{ v.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    scroll: {
      type: Boolean,
      default: false
    },
    disabledFirst: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    disabledJump: {
      type: Boolean,
      default: false
    },
    steps: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      className: ""
    };
  },
  methods: {
    swichPage(name, i) {
      if (!name) {
        return;
      }
      // 禁止跳转页面
      if (this.disabledJump) {
        this.$emit("toNext", i + 1);
        return;
      }
      // 全局禁止点击
      if (!this.scroll) {
        // 禁止当前步的下一步
        if (this.disabledNext) {
          if (i + 1 <= this.step) {
            // 禁止编辑第一个
            if (this.disabledFirst) {
              if (i !== 0) {
                this.$router.push({ name, query: { type: "edit" } });
              }
            } else {
              this.$router.push({ name });
            }
          }
        } else {
          // 禁止编辑第一个
          if (this.disabledFirst) {
            this.$router.push({ name, query: { type: "edit" } });
          } else {
            this.$router.push({ name });
          }
        }
      } else {
        this.$emit("scroll", i);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.step-wrapper {
  background: #fff;
  padding: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
  word-break: keep-all;
  user-select: none;
}

.step {
  position: relative;
  background: #eeeeee;
  padding: 10px 30px;
  margin-right: 18px;
  height: 37px;
  word-break: keep-all;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
  .num {
    display: inline-block;
    width: 12px;
    height: 12px;
    line-height: 12px;
    background: #222222;
    padding: 4px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    margin-right: 10px;
  }
}

.step.prev {
  background: #fedeec;
  color: #e50065;
  .num {
    background: #e50065;
    color: #fff;
  }
}

.step.prev:after {
  border-left-color: #fedeec;
}

.step.active {
  background: #e50065;
  color: #fff;
  .num {
    background: #fff;
    color: #e50065;
  }
}
.step.active:after {
  border-left-color: #e50065;
}

.step:after {
  position: absolute;
  right: -36px;
  top: 0;
  content: "";
  border: 18px solid transparent;
  border-left-color: #eeeeee;
}

.step::before {
  position: absolute;
  left: 0;
  top: 0;
  content: "";
  border: 18px solid transparent;
  border-left-color: #fff;
}
.step:first-child::before {
  display: none;
}

.disabled {
  background: #f9f9f9 !important;
  color: #878787 !important;
  cursor: unset;
  .num {
    background: #999999 !important;
  }
}
.disabled::after {
  border-left-color: #f9f9f9 !important;
}
</style>
